<template>
    <v-card max-width="530px">
        <div class="pa-6 d-flex flex-column">
            <strong>{{ $t('new_event_express_title') }}</strong>
            <div class="mt-3 d-flex flex-row">
                <v-img :src="newEventExpressIcon" height="153px" contain />
                <div class="ml-3 d-flex flex-column">
                    <p class="tgk-paragraph-text">{{ $t('new_event_express_text') }}</p>
                    <v-btn
                        class="mt-3"
                        max-width="220px"
                        color="primary"
                        :to="emitEvents ? null : { name: 'event-express-edit', params: { id: 'new' } }"
                        @click="emitEvents ? $emit('event-express-edit') : null"
                    >
                        <KpIcon icon-cls="next" color="white" disabled-color="grey" left />
                        {{ $t('new_event_express') }}
                    </v-btn>
                </div>
            </div>
        </div>
        <v-divider />
        <div class="pa-6 d-flex flex-column">
            <strong>{{ $t('new_event_erweitert_title') }}</strong>
            <div class="mt-3 d-flex flex-row">
                <v-img :src="newEventErweitertIcon" height="153px" contain />
                <div class="ml-3 d-flex flex-column">
                    <p class="tgk-paragraph-text">{{ $t('new_event_erweitert_text') }}</p>
                    <v-btn
                        class="mt-3"
                        max-width="220px"
                        color="primary"
                        :to="emitEvents ? null : { name: 'event-edit', params: { id: 'new' } }"
                        @click="emitEvents ? $emit('event-edit') : null"
                    >
                        <KpIcon icon-cls="next" color="white" disabled-color="grey" left />
                        {{ $t('new_event_erweitert') }}
                    </v-btn>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
import newEventExpressIcon from '@/assets/images/tgk-superwoman.svg';
import newEventErweitertIcon from '@/assets/images/tgk-fee.svg';

export default {
    name: 'EventNewMenu',

    props: {
        emitEvents: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            newEventExpressIcon,
            newEventErweitertIcon,
        };
    },
};
</script>
